(() => {
  function initialize(gate) {
    if (gate.ageGateInitialized || !gate.hasAttribute('data-open')) return;
    gate.ageGateInitialized = true;
    const yes = gate.querySelector('[data-age-yes]');
    const buttons = Array.from(gate.querySelectorAll('button'));
    const designMode = gate.dataset.designMode === 'true';
    const state = gate.ageGateState;
    function keepFocus(event) {
      if (!gate.contains(event.target)) yes.focus({ preventScroll: true });
    }
    function trapKeys(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (event.key === 'Tab') {
        event.preventDefault();
        const index = buttons.indexOf(document.activeElement);
        const next = index === -1 ? (event.shiftKey ? buttons.length - 1 : 0)
          : (index + (event.shiftKey ? buttons.length - 1 : 1)) % buttons.length;
        buttons[next].focus();
      }
    }
    function close() {
      if (!gate.hasAttribute('data-open')) return;
      gate.removeAttribute('data-open');
      state.observer.disconnect();
      state.background.forEach((attributes, element) => {
        [['inert', attributes.inert], ['aria-hidden', attributes.ariaHidden]].forEach(([name, value]) => {
          if (value === null) element.removeAttribute(name);
          else element.setAttribute(name, value);
        });
      });
      document.removeEventListener('focusin', keepFocus);
      document.removeEventListener('keydown', trapKeys, true);
      [document.documentElement, document.body].forEach((element, index) => {
        state.styles[index].forEach(([name, value, priority]) => {
          if (value) element.style.setProperty(name, value, priority);
          else element.style.removeProperty(name);
        });
      });
      state.parent.insertBefore(gate, state.nextSibling?.parentNode === state.parent ? state.nextSibling : null);
      window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
      const target = state.focus && state.focus !== document.body && state.focus.isConnected
        ? state.focus : document.querySelector('.skip-to-content-link, main');
      if (target) target.focus({ preventScroll: true });
      document.removeEventListener('shopify:section:unload', unload);
    }
    function unload(event) {
      if (event.target.contains(gate) || event.target.contains(state.parent)) close();
    }
    document.addEventListener('focusin', keepFocus);
    document.addEventListener('keydown', trapKeys, true);
    document.addEventListener('shopify:section:unload', unload);
    yes.addEventListener('click', () => {
      if (!designMode) {
        const configuredDays = Number(gate.dataset.days);
        const days = Number.isFinite(configuredDays) && configuredDays > 0 ? configuredDays : 30;
        try {
          document.cookie = `age_verified=1; path=/; max-age=${Math.floor(days * 86400)}; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
        } catch (error) {}
      }
      close();
    });
    gate.querySelector('[data-age-no]').addEventListener('click', () => {
      window.location.href = (gate.dataset.redirect || '').trim() || 'https://www.google.com';
    });
    gate.querySelector('[data-age-dismiss]')?.addEventListener('click', close);
    yes.focus({ preventScroll: true });
  }
  document.querySelectorAll('[data-age-gate]').forEach(initialize);
  if (!window.ageGateEditorListener) {
    window.ageGateEditorListener = true;
    document.addEventListener('shopify:section:load', event => {
      document.querySelectorAll('[data-age-gate]').forEach(initialize);
    });
  }
})();
